"use client";

import React, { useRef, useState } from "react";
import { Popover } from "antd";
import { Popup, Ellipsis, ImageViewer } from "antd-mobile";

import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Autoplay, Controller, Pagination, Scrollbar } from "swiper";
import BrandPopover from "./brandPopover";
import { useSharedData } from "bossjob-remote/dist/hooks";

import "swiper/swiper.min.css";
import styled from "@emotion/styled";
import { Global, css } from "@emotion/react";

const BrandSwiper = (props) => {
  const data = props.data;
  const isMobile = props.isMobile;
  const brandProduct = data?.brand_and_product_info ?? [];
  const [curBrandProduct, setCurBrandProduct] = useState<any>({});
  const [curViewerImg, setCurViewerImg] = useState<any>({});
  const [showPrevArrow, setShowPrevArrow] = useState(false);
  const [showNextArrow, setShowNextArrow] = useState(brandProduct?.length > 1 ? true : false);
  const [showPopupType, setShowPopupType] = useState("");
  const langDic = useSharedData("DICTIONARY") || {};
  const companyDetailLangDic = langDic?.companyDetail || {};
  const previewImgs = curViewerImg?.pictures || [];
  const previewIndex = curViewerImg?.index || 0;

  const swiperRef = useRef(null);
  const pageType = props.pageType;

  const handleShowPopupType = (popType, data = null) => {
    if (data !== null) {
      setCurBrandProduct(data);
    }
    setTimeout(() => {
      setShowPopupType(popType);
    }, 500);
  };

  const handleSlideChange = () => {
    if (swiperRef.current) {
      setShowPrevArrow(swiperRef.current.swiper.isBeginning === false);
      setShowNextArrow(swiperRef.current.swiper.isEnd === false);
    }
  };

  const CustomPrevArrow = () => (
    <span
      className='swiper-button-prev'
      onClick={(e) => {
        e.stopPropagation();
        swiperRef.current.swiper.slidePrev();
      }}
    >
      <PreIcon />
    </span>
  );

  const CustomNextArrow = () => (
    <span
      className='swiper-button-next'
      onClick={(e) => {
        e.stopPropagation();
        swiperRef.current.swiper.slideNext();
      }}
    >
      <NextIcon />
    </span>
  );

  if (!brandProduct.length) {
    return null;
  }
  return (
    <>
      <Global styles={GlobalStyles} />
      <BrandSwiperWrap>
        <div
          style={{
            padding: 0
          }}
          className={
            !isMobile && pageType === "job-detail" ? "brand-swiper-wrap" : "brand-swiper-wrap-1"
          }
        >
          <div className='swiper-wrap'>
            <Swiper
              modules={[Pagination, Scrollbar, A11y, Autoplay, Controller]}
              ref={swiperRef}
              spaceBetween={13.6}
              slidesPerView={1.5}
              grabCursor={true}
              // autoplay={{
              // 	delay: 10 * 1000,
              // 	disableOnInteraction: true
              // }}
              loop={false}
              scrollbar={{ draggable: true }}
              className='brand-swiper'
              onSlideChange={handleSlideChange}
            >
              {brandProduct.map((item, index) => (
                <SwiperSlide key={index}>
                  <div
                    // style={{ width: 227 }}
                    className='item'
                    // onClick={() => isMobile && handleShowPopupType("brand-popup", item)}
                  >
                    <Popover
                      placement='left'
                      mouseEnterDelay={0.5}
                      trigger={"hover"}
                      overlayClassName='custom-popover'
                      content={!isMobile && <BrandPopover data={item} />}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center"
                        }}
                      >
                        <img className='avatar' src={item.logo_url} alt='img' />
                        <div className='item-right'>
                          <div className='brand-name'>{item.title}</div>
                          {/* <div className='brand-intro'>{item.description}</div> */}
                        </div>
                      </div>
                    </Popover>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            {showPrevArrow && !isMobile ? <CustomPrevArrow /> : null}
            {showNextArrow && !isMobile && brandProduct.length ? <CustomNextArrow /> : null}
          </div>
        </div>
        <Popup
          visible={showPopupType === "brand-popup"}
          className='brand-popup'
          bodyStyle={{ maxHeight: "80vh", borderRadius: "16px 16px 0px 0px", overflowY: "auto" }}
        >
          <div style={{ padding: "16px", paddingBottom: "24px" }}>
            {showPopupType === "brand-popup" ? (
              <>
                <div className='pop-top'>
                  <span
                    className='close-icon'
                    onClick={() => {
                      handleShowPopupType("");
                    }}
                  >
                    <CloseIcon />
                  </span>
                  <div>
                    <img className='logo' src={curBrandProduct.logo_url} alt='img' />
                  </div>
                  <p className='brand-name'>{curBrandProduct.title}</p>
                  <p className='brand-slogan'>{curBrandProduct.sub_title}</p>
                </div>
                <div className='brand-intro'>
                  <Ellipsis
                    rows={3}
                    content={curBrandProduct.description}
                    expandText={
                      <span className='more'>{companyDetailLangDic?.overview?.More}</span>
                    }
                    collapseText={
                      <span className='less'>{companyDetailLangDic?.overview?.Less}</span>
                    }
                  ></Ellipsis>
                </div>
                {curBrandProduct?.pictures?.length ? (
                  <div className='related-pictures'>
                    {curBrandProduct.pictures.map((item, idx) => (
                      <img
                        key={item}
                        src={item}
                        onClick={() => {
                          setCurViewerImg({ pictures: curBrandProduct.pictures, index: idx });
                        }}
                      />
                    ))}
                  </div>
                ) : null}
              </>
            ) : null}
          </div>
        </Popup>
        {
          // 多图显示
          previewImgs?.length ? (
            <ImageViewer.Multi
              images={previewImgs || []}
              visible={previewImgs}
              defaultIndex={previewIndex}
              classNames={{
                mask: "custom-img-viewer-mask",
                body:
                  pageType == "job-detail"
                    ? "custom-img-viewer-body-job-detail"
                    : "custom-img-viewer-body"
              }}
              maxZoom='auto'
              onClose={() => {
                setCurViewerImg({});
              }}
            />
          ) : // 单图显示
          // <ImageViewer
          //   classNames={{
          //     mask: 'custom-img-viewer-mask',
          //     body: 'custom-img-viewer-body',
          //   }}
          //   image={previewImgs[previewIndex].url}
          //   visible={previewImgs}
          //   onClose={() => {
          //     setCurViewerImg({})
          //   }}
          // />
          null
        }
      </BrandSwiperWrap>
    </>
  );
};

export default BrandSwiper;

const GlobalStyles = css`
  html,
  body {
    .custom-popover {
      .ant-popover-arrow {
        //display: none;
      }
    }
    .brand-popup {
      .more,
      .less {
        color: #2378e5;
        cursor: pointer;
      }
      .pop-top {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 6px;
        flex-direction: column;
        align-items: center;
        .logo {
          margin-top: 4px;
          width: 50px;
          height: 50px;
          border-radius: 8px;
        }
        .brand-name {
          color: #121212;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
        }
        .brand-slogan {
          color: #7d7d7d;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
        }
      }
      .brand-intro {
        color: #515151;
        font-size: 14px;
        line-height: normal;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .related-pictures {
        margin-top: 16px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 12px;
        img {
          width: calc(33.333% - 8px);
          height: 80px;
          object-fit: cover;
        }
      }
      .close-icon {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
      }
    }
    .custom-img-viewer-mask {
      z-index: 2000 !important;
    }
    .custom-img-viewer-body {
      img {
        border-radius: 0;
        border: none;
      }
    }
    .custom-img-viewer-body-job-detail {
      .adm-image-viewer-slides-inner > * {
        margin-right: 0;
      }
    }
  }
`;

const BrandSwiperWrap = styled.div`
  /* border-radius: 8px;
  background: #ffffff; */
  margin: 0 24px;

  .page-line {
    width: 100%;
    height: 1px;
    padding: 0 16px;
    background: #ffffff;

    &::after {
      content: "";
      display: block;
      width: 100%;
      border-bottom: 1px solid #e4e4e4;
    }
  }

  .brand-swiper-wrap {
    padding: 20px;
  }

  .brand-swiper-wrap-1 {
    padding: 20px 20px 0;
  }

  .block-title {
    color: #121212;
    font-size: 20px;
    font-weight: 700;
  }

  .swiper-wrap {
    position: relative;
    width: 100%;
    margin: 17px 0 10px;
  }

  .item {
    position: relative;
    display: flex;
    align-items: center;
    /* padding: 16px 0; */

    /* gap: 16px; */
    /* border: 1px solid #e5e6eb; */
    background: transparent;
    &:hover {
      .item-popup {
        display: block;
      }
    }
    .avatar {
      width: 32px;
      height: 32px;
      margin-right: 8px;
      border-radius: 3px;
    }
    .item-right {
      /* width: calc(100% - 64px); */
      /* flex: 1; */
      flex-shrink: 1;
      display: flex;
      line-height: 20;
      /* align-items: center; */
      flex-direction: column;
      .brand-name {
        line-height: 20px;
        color: #121212;
        font-size: 14px;
        /* white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis; */
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .brand-intro {
        line-height: 1;
        color: #7d7d7d;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
    }
  }

  .item-popup {
    display: none;
    position: absolute;
    width: 502px;
    right: 222px;
    z-index: 999999;
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    width: 16px;
    height: 16px;
    box-sizing: content-box;
    padding: 3px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 20px;
    background: #fff;

    box-shadow: 0px 4px 6px 0px rgba(162, 183, 203, 0.1);

    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 200;
    cursor: pointer;
    &:hover {
      background: #f4f5f6;

      box-shadow: 0px 4px 6px 0px rgba(162, 183, 203, 0.1);
    }
  }

  .swiper-button-prev {
    left: -6px;
  }

  .swiper-button-next {
    right: -6px;
  }
`;

const PreIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.08925 4.99999L6.78914 2.30011C6.95186 2.13739 6.95186 1.87357 6.78914 1.71085L6.70075 1.62247C6.53803 1.45975 6.27421 1.45975 6.11149 1.62247L2.73397 4.99999L6.11149 8.37752C6.27421 8.54024 6.53803 8.54024 6.70075 8.37752L6.78914 8.28913C6.95186 8.12641 6.95186 7.8626 6.78914 7.69988L4.08925 4.99999Z'
        fill='#ACAEB1'
      />
    </svg>
  );
};

const NextIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.72848 5.00001L3.0286 2.30012C2.86588 2.1374 2.86588 1.87359 3.0286 1.71087L3.11699 1.62248C3.27971 1.45976 3.54352 1.45976 3.70624 1.62248L7.08377 5.00001L3.70624 8.37753C3.54352 8.54025 3.27971 8.54025 3.11699 8.37753L3.0286 8.28914C2.86588 8.12643 2.86588 7.86261 3.0286 7.69989L5.72848 5.00001Z'
        fill='#ACAEB1'
      />
    </svg>
  );
};

const CloseIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <path
      d='M6.5 6.5L17.5 17.5'
      stroke='#121212'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.5 17.5L17.5 6.5'
      stroke='#121212'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
